import React from 'react'
import styled from 'styled-components'

export const KdabraTabs = styled.div`
  button:first-child {
    border-radius: 20px 0 0 0;
  }

  button:last-child {
    border-radius: 0 20px 0 0;
  }

  margin-bottom: -3px;
  margin-left: -2px;
`

const Tab = styled.button`
  background-color: ${(props) => (props.active ? '#002962' : '#5C81B9')};
  color: #ffffff;
  padding: 10px 20px;
  font-weight: 600;
  border-left: 2px solid #ffffff;
  border-right: none;
  border-top: none;
  border-bottom: none;
`

function Tabs({ tabs, activeTab }) {
  return (
    <KdabraTabs>
      {tabs.map((tab) => (
        <Tab
          key={tab.title}
          active={activeTab == tab.title}
          onClick={tab.action}
        >
          {tab.title}
        </Tab>
      ))}
    </KdabraTabs>
  )
}

export default Tabs
